import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomePage.vue'),
  },
  {
    path: '/solution',
    name: 'Solution',
    component: () => import('../views/Solution.vue'),
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue'),
  },
  {
    path: '/aboutQD',
    name: 'AboutQD',
    component: () => import('../views/AboutQD.vue'),
  },
  {
    path: '/generateQR',
    name: 'GenerateQR',
    component: () => import('../views/GenerateQR.vue'),
  },
  {
    path: '/contactUs',
    name: 'ContactUs',
    component: () => import('../views/ContactUs.vue'),
  },
  {
    path: '/customerCases',
    name: 'CustomerCases',
    component: () => import('../views/CustomerCases.vue'),
  },
];
const router = new Router({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

export default router;
